<template>
    <list-cell-icon
        :icon="icon"
        :color="color"
    />
</template>

<script setup lang="ts">
    import { Score } from '@keyvue/one-api-client';
    import { Color, ListCellIcon } from '@keyvue/one-ui';
    import { computed } from 'vue';

    import IconPositive from '@keyvue/one-material-icons/icons/sentiment_satisfied.svg?component';
    import IconNegative from '@keyvue/one-material-icons/icons/sentiment_dissatisfied.svg?component';
    import IconNeutral from '@keyvue/one-material-icons/icons/sentiment_neutral.svg?component';

    const props = defineProps<{
        score: Score,
    }>();

    const iconMap = {
        [Score.POSITIVE.value]: IconPositive,
        [Score.NEGATIVE.value]: IconNegative,
        [Score.NEUTRAL.value]: IconNeutral,
    };

    const colorMap = {
        [Score.POSITIVE.value]: Color.brandGreen,
        [Score.NEGATIVE.value]: Color.red500,
        [Score.NEUTRAL.value]: Color.orange500,
    };

    const icon = computed(() => iconMap[props.score.value]);
    const color = computed(() => colorMap[props.score.value]);
</script>
